/**
 * Feature Flags Configuration
 * 
 * Toggle features on/off for different versions or demos
 */

const featureFlags = {
  // V3 features - new branch selector and terminal
  showV3: true,
  showConfigonly: false,
  openInCursor: false, // if true, do cursor. if false, open as a code modal like an ide. 
};



export default featureFlags;
